import { formatPrice } from 'common/utils/format'
import { DISCOUNT_METHODS } from 'artkive/utils/promoCode'

const calculateAddonViewPrices = ({
  fullPriceInfo = {},
  enableUSBAddon = false,
  isOrderSummary = false,
  isAddonSummary = false,
}) => {
  const { promo_discount_details, base_price = 0, currency_symbol } = fullPriceInfo
  const { discount_method: discountMethod, amount = 0 } = promo_discount_details || {}

  if (!Number(base_price)) {
    return { finalPrice: 'FREE', price: undefined, discountLabel: null }
  }

  const prefix = isOrderSummary || isAddonSummary ? '+ ' : ''
  let finalPrice
  let discountLabel
  let price

  switch (discountMethod) {
    case DISCOUNT_METHODS.PERCENTAGE:
      finalPrice = `${prefix}${formatPrice(base_price * (1 - amount), 'long', currency_symbol)}`
      price = formatPrice(base_price, 'long', currency_symbol)
      discountLabel = `-${amount * 100}%`
      break
    case DISCOUNT_METHODS.FREE_USB:
      finalPrice = `${prefix}${formatPrice(base_price, 'long', currency_symbol)}`
      if (enableUSBAddon) {
        if (isOrderSummary) {
          finalPrice = null
          price = formatPrice(base_price, 'long', currency_symbol)
        }
        discountLabel = 'FREE'
      }
      break
    default:
      finalPrice = `${prefix}${formatPrice(base_price, 'long', currency_symbol)}`
      discountLabel = null
  }

  return {
    finalPrice,
    price,
    discountLabel,
  }
}

export default calculateAddonViewPrices
